import styles from './ToggleCard.module.scss';
import CardImage from '@ui/components/Card/components/CardImage/CardImage';
import Heading from '@ui/components/Heading/Heading';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import Switch from '@ui/components/Switch/Switch';
import Content from '@ui/components/Content/Content';
import Card from '@ui/components/Card/Card';
import React from 'react';
import PropTypes from 'prop-types';
import { getHeadingTag } from '../../utils';

const ToggleCard = ({
  disabled = false,
  glyph,
  image,
  headingLevel = 3,
  legalText,
  store,
  title,
  toggleLabel,
  value,
}) => (
  <Card className={styles.container}>
    <div className={styles.infoContainer}>
      {!!glyph && (
        <FontAwesomeProIcon
          className={styles.icon}
          icon={glyph}
          role="presentation"
        />
      )}
      {!!image && (
        <CardImage
          className={styles.imageIcon}
          height={64}
          image={{ ...image, ...{ alt: title } }}
          role="presentation"
        />
      )}
      <Heading
        as={getHeadingTag(headingLevel)}
        className={styles.title}
        size="h6"
      >
        {title}
      </Heading>
      {!!legalText && (
        <Content className={styles.legalText} noSpacing withParser>
          {legalText}
        </Content>
      )}
    </div>
    <div className={styles.toggleContainer}>
      <Content noSpacing>{toggleLabel}</Content>
      <Switch disabled={disabled} store={store} value={value} />
    </div>
  </Card>
);

ToggleCard.propTypes = {
  disabled: PropTypes.bool,
  glyph: PropTypes.string,
  headingLevel: PropTypes.number,
  image: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
  }),
  legalText: PropTypes.string,
  /* eslint-disable react/forbid-prop-types */
  /** `useCheckboxStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  toggleLabel: PropTypes.string.isRequired,
  value: PropTypes.string,
};

export default ToggleCard;
